
import Vue from 'vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Search from 'vux/src/components/search/index.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import Loading from './pages/components/Loading'
import FullscreenImg from './pages/components/FullscreenImg'


Vue.component('Group', Group)
Vue.component('Cell', Cell)
Vue.component('Datetime', Datetime)
Vue.component('ButtonTab', ButtonTab)
Vue.component('ButtonTabItem', ButtonTabItem)
Vue.component('Divider', Divider)
Vue.component('Search', Search)
Vue.component('XInput', XInput)
Vue.component('XButton', XButton)
Vue.component('XHeader', XHeader)
Vue.component('XSwitch', XSwitch)

Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)

import NavBar from './pages/components/NavBar'
import cookie from './utils/cookie'
import pageUtil from './utils/page'
import tlstore from './store/tlconfig'
import LoginDialog from './tlpage/LoginDialog'


const sessionHistory = window.sessionStorage
export default {
data () {
return {
transitionName: 'forward'
}
},
components: {
ViewBox,
Loading,
Tabbar,
TabbarItem,
FullscreenImg,
LoginDialog
},
methods: {
clear () {

},
hidedialog:function(isHide){
this.showLoginDialog=isHide;
},
setshow:function(){
this.showLoginDialog=true;
}
},
watch: {

'$route' (to, from) {
if (to && from) {
let toPath = to.path
let fromPath = from.path
let count = parseInt(sessionHistory.getItem('count'))

if (Number.isNaN(count)) {
count = 1
this.transitionName = 'forward'
} else {
count += 1
let fromCount = parseInt(sessionHistory.getItem(fromPath))
let toCount = parseInt(sessionHistory.getItem(toPath))
if (toCount < fromCount && fromCount < count && (!pageUtil.showNav(fromPath))) {
this.transitionName = 'backward'
count = toCount
} else {
this.transitionName = 'forward'
}
if (pageUtil.showNav(toPath)) {
count = 1
}
}
sessionHistory.setItem(toPath, count)
sessionHistory.setItem('count', count)
}
}
},
updated () {

this.$store.dispatch('hideLoading')
if(tlstore.state.hasLogin){
this.$store.dispatch('connect')
this.$store.dispatch('updateRefreshState')
}

},
computed: {
sysMsgUnread () {
let unReadCount=0;
for(var item in this.$store.state.sessionlist){
unReadCount+=this.$store.state.sessionlist[item].unread
}

return unReadCount
},

showNav () {
return pageUtil.showNav(this.$route.path)
},
isLogin () {
return tlstore.state.hasLogin;
}
},
data () {
return {
msgN: 3,
showLoginDialog:false
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue